import React from 'react';
import { Card } from 'react-bootstrap';
import { CardBox, CardFrame, CardText, SeparationText, CardBody } from './IntroStyled';
import { Body, ChildTitle } from '../Common/CommonStyled';
// import { ServersData } from '../../utils/dbService';
import { pastorsData } from '../../constants/pastor.const';
import { pastorsImg } from '../../imgs/pastorsImg';

function Pastors() {
  // const serversData = ServersData();

  return (
    <Body>
      <ChildTitle>교역자 소개</ChildTitle>
      {pastorsData.map((obj, i) => (
        <React.Fragment key={i}>
          <SeparationText>{obj.title}</SeparationText>
          <CardBox>
            {obj.cardData.map((card, j) => (
              <CardFrame key={j}>
                <Card>
                  <Card.Img variant="top" src={pastorsImg[card.img]} />
                  <CardBody>
                    <CardText>{`${card.name} ${obj.title}`}</CardText>
                  </CardBody>
                </Card>
              </CardFrame>
            ))}
          </CardBox>
        </React.Fragment>
      ))}
      {/* {serversData && serversData.slice(0, 1).map((arr, i) => (
        <div key={i}>
          <SeparationText>{arr.separationText}</SeparationText>
          <CardBox>
            {arr.contentsArr.map((obj, j) => (
              <CardFrame key={j}>
                <Card>
                  <Card.Img variant="top" src={obj.imgUrls[0]} />
                  <CardBody>
                    <CardText>{obj.name}</CardText>
                  </CardBody>
                </Card>
              </CardFrame>
            ))}
          </CardBox>
        </div>
      ))} */}
    </Body>
  );
}

export default Pastors;